import React from 'react';
import { TargetCriteriaCard } from './targetCriteriaCard';

/** Per-target TEACHING -> MASTERED rule (client goal and library goal). */
export const BaselineMastery = ({ target, isLibrary }) => <TargetCriteriaCard kind="mastery" target={target} isLibrary={isLibrary} />;
